import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Sidebar({ aberta, setAberta }) {
  const navigate = useNavigate();
  const location = useLocation();
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isCliente = usuario.perfil === 'cliente';
  const isSuperadmin = usuario.perfil === 'superadmin';

  const menusAdmin = [
    { icon: '🗺️', label: 'Monitoramento', path: '/dashboard' },
    { icon: '⚡', label: 'Cadastro Rápido', path: '/cadastro-rapido' },
    { icon: '👥', label: 'Clientes', path: '/clientes' },
    { icon: '📟', label: 'Equipamentos', path: '/equipamentos' },
    { icon: '📡', label: 'Linhas GPRS', path: '/linhas' },
    { icon: '🚗', label: 'Targets', path: '/targets' },
    { icon: '🔑', label: 'Logins', path: '/logins' },
    { icon: '🔔', label: 'Alertas', path: '/alertas' },
    { icon: '📊', label: 'Relatórios', path: '/relatorios' },
    { icon: '🛡️', label: 'Auditoria', path: '/auditoria' },
    { icon: '🔧', label: 'Manutenção', path: '/manutencoes' },
    { icon: '🔌', label: 'Instalador', path: '/instalador' },
    { icon: '💰', label: 'Financeiro', path: '/financeiro' },
    { icon: '📋', label: 'Contratos', path: '/contratos' },
    { icon: '📈', label: 'Estatísticas', path: '/estatisticas' },
    { icon: '💡', label: 'Sugestões', path: '/sugestoes' },
    { icon: '⚙️', label: 'Configurações', path: '/configuracoes' },
  ];

  const menusSuperadmin = [
    ...menusAdmin,
    { icon: '🤝', label: 'Parceiros', path: '/parceiros', destaque: true },
  ];

  const menusCliente = [
    { icon: '🗺️', label: 'Monitoramento', path: '/dashboard' },
    { icon: '🔔', label: 'Alertas', path: '/alertas' },
    { icon: '🔧', label: 'Manutenção', path: '/manutencoes' },
    { icon: '💳', label: 'Minhas Cobranças', path: '/minhas-cobrancas' },
    { icon: '💡', label: 'Sugestões', path: '/sugestoes' },
  ];

  const menus = isCliente ? menusCliente : isSuperadmin ? menusSuperadmin : menusAdmin;

  return (
    <>
      {aberta && (
        <div onClick={() => setAberta(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99999 }} />
      )}
      <div style={{
        position: 'fixed', top: 0, left: aberta ? 0 : '-260px',
        width: '260px', height: '100vh', background: '#1a1a2e',
        zIndex: 100000, transition: 'left 0.3s ease',
        display: 'flex', flexDirection: 'column',
        boxShadow: aberta ? '4px 0 20px rgba(0,0,0,0.5)' : 'none'
      }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '24px' }}>🛰️</span>
            <div>
              <div style={{ color: '#1D9E75', fontWeight: '700', fontSize: '15px' }}>Rastreamento</div>
              <div style={{ color: '#888', fontSize: '11px' }}>{isCliente ? 'Área do Cliente' : isSuperadmin ? 'Super Admin' : 'Painel Admin'}</div>
            </div>
          </div>
          <button onClick={() => setAberta(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', fontSize: '18px', cursor: 'pointer', borderRadius: '6px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
          {menus.map((menu, i) => {
            const ativo = location.pathname === menu.path;
            return (
              <div key={i} onClick={() => { navigate(menu.path); setAberta(false); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 20px', cursor: 'pointer',
                  background: ativo ? 'rgba(29,158,117,0.2)' : menu.destaque ? 'rgba(29,158,117,0.08)' : 'transparent',
                  borderLeft: ativo ? '3px solid #1D9E75' : menu.destaque ? '3px solid rgba(29,158,117,0.4)' : '3px solid transparent',
                  transition: 'all 0.2s',
                  marginTop: menu.destaque ? '8px' : 0,
                  borderTop: menu.destaque ? '1px solid rgba(255,255,255,0.08)' : 'none'
                }}
                onMouseEnter={e => { if (!ativo) e.currentTarget.style.background = 'rgba(255,255,255,0.05)' }}
                onMouseLeave={e => { if (!ativo) e.currentTarget.style.background = menu.destaque ? 'rgba(29,158,117,0.08)' : 'transparent' }}>
                <span style={{ fontSize: '18px' }}>{menu.icon}</span>
                <span style={{ color: ativo ? '#1D9E75' : menu.destaque ? '#1D9E75' : '#ccc', fontSize: '14px', fontWeight: ativo || menu.destaque ? '600' : '400' }}>{menu.label}</span>
              </div>
            );
          })}
        </div>

        <div style={{ padding: '14px 20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ color: '#555', fontSize: '11px', textAlign: 'center' }}>
            Desenvolvido por{' '}
            <a href="https://digitalmaisbr.com.br" style={{ color: '#1D9E75' }}>Digital Mais BR</a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;